import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { add, deleteRecord, fetch, update } from '../services/SubscriptionsService';
import { Subscription } from '../types';

export const useSubscription = (subscriptionId?: string) => {
    const queryClient = useQueryClient();

    // FETCH QUERY
    const subscriptionQuery = useQuery({
        queryKey: ['subscription', subscriptionId],
        queryFn: () => fetch(subscriptionId as string),
        enabled: !!subscriptionId
    });

    // CREATE MUTATION
    const createMutation = useMutation({
        mutationFn: (values: Subscription) => {
            const { created: _created, updated: _updated, ...rest } = values;
            return add(rest);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
        }
    });

    // UPDATE MUTATION
    const updateMutation = useMutation({
        mutationFn: (values: Subscription) => {
            if (!subscriptionId) throw new Error('subscriptionId is required parameter');
            return update(subscriptionId, values);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
            queryClient.invalidateQueries({ queryKey: ['subscription', subscriptionId] });
        }
    });

    // DELETE MUTATION
    const deleteMutation = useMutation({
        mutationFn: () => {
            if (!subscriptionId) throw new Error('subscriptionId is required parameter');
            return deleteRecord(subscriptionId);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
        }
    });

    return {
        record: subscriptionQuery.data,
        loading: subscriptionQuery.isLoading,
        error: subscriptionQuery.error,
        createRecord: createMutation.mutateAsync,
        updateRecord: updateMutation.mutateAsync,
        deleteRecord: deleteMutation.mutateAsync,
        createMutation,
        updateMutation,
        deleteMutation
    };
};


